(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["compare-panel"] && !Shopify.designMode) return;
  try {
    (function () {
    // Check if compare panel is already initialized to prevent duplicates
    if (window.__comparePanelInitialized) {
      return;
    }
    window.__comparePanelInitialized = true;

    // Remove any duplicate panels if they exist
    const allPanels = document.querySelectorAll('#ComparePanel');
    const allOverlays = document.querySelectorAll('#ComparePanelOverlay');
    if (allPanels.length > 1) {
      for (let i = 1; i < allPanels.length; i++) {
        allPanels[i].remove();
      }
    }
    if (allOverlays.length > 1) {
      for (let i = 1; i < allOverlays.length; i++) {
        allOverlays[i].remove();
      }
    }

    const panel = document.getElementById('ComparePanel');
    const overlay = document.getElementById('ComparePanelOverlay');
    const closeBtn = panel.querySelector('.compare-panel__close');
    const content = document.getElementById('CompareContent');
    const clearAllBtn = document.getElementById('ClearAllCompare');
    const storageKey = 'pwCompareProducts';

    // Get compare products from localStorage
    function getCompareProducts() {
      try {
        return JSON.parse(localStorage.getItem(storageKey)) || [];
      } catch {
        return [];
      }
    }

    // Save compare products to localStorage
    function saveCompareProducts(products) {
      localStorage.setItem(storageKey, JSON.stringify(products));
      updatePanelDisplay();
      dispatchEvent();
    }

    // Remove product from comparison
    function removeProduct(handle) {
      const products = getCompareProducts();
      const filtered = products.filter(p => p.handle !== handle);
      saveCompareProducts(filtered);
    }

    // Prevent duplicate opens
    let isOpening = false;

    // Add product to comparison
    window.addToCompare = function (productData) {
      const products = getCompareProducts();
      
      // Check if product already exists
      if (products.some(p => p.handle === productData.handle)) {
        removeProduct(productData.handle);
        return;
      }
      
      products.push(productData);
      saveCompareProducts(products);
      
      // Prevent duplicate opens
      if (!isOpening) {
        isOpening = true;
        openPanel();
        setTimeout(() => { isOpening = false; }, 100);
      }
    };

    // Update panel display
    function updatePanelDisplay() {
      const products = getCompareProducts();
      
      // Filter out products with invalid data
      const validProducts = products.filter(p => 
        p && p.handle && p.title && p.title !== 'undefined'
      );
      
      if (validProducts.length === 0) {
        content.innerHTML = '<div class="compare-panel__empty"><p>' + 
          document.querySelector('[data-i18n-compare-empty]')?.textContent || 'No products to compare' + 
          '</p></div>';
        return;
      }

      content.innerHTML = validProducts.map(product => {
        const imageHtml = product.image && product.image !== 'undefined' 
          ? `<img src="${product.image}" alt="${product.title}" loading="lazy">`
          : `<div style="width: 100%; height: 100%; background: #f0f0f0; display: flex; align-items: center; justify-content: center; color: #ccc;">No Image</div>`;
        
        return `
        <div class="compare-item">
          <div class="compare-item__image">
            ${imageHtml}
          </div>
          <div class="compare-item__details">
            <a href="${product.url || '#'}" class="compare-item__title">${product.title || 'Product'}</a>
            <div class="compare-item__price">${product.price || '$0.00'}</div>
            <button 
              type="button" 
              class="compare-item__remove" 
              data-handle="${product.handle}"
              onclick="window.removeFromCompare('${product.handle}')"
            >Remove</button>
          </div>
        </div>
      `;
      }).join('');
    }

    // Remove from compare
    window.removeFromCompare = function (handle) {
      removeProduct(handle);
    };

    // Open panel
    function openPanel() {
      panel.classList.add('is-active');
      overlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    }

    // Close panel
    function closePanel() {
      panel.classList.remove('is-active');
      overlay.classList.remove('is-active');
      document.body.style.overflow = '';
    }

    // Event listeners
    closeBtn.addEventListener('click', closePanel);
    overlay.addEventListener('click', closePanel);
    
    if (clearAllBtn) {
      clearAllBtn.addEventListener('click', () => {
        localStorage.removeItem(storageKey);
        updatePanelDisplay();
        dispatchEvent();
      });
    }

    // Dispatch custom event for count updates
    function dispatchEvent() {
      const products = getCompareProducts();
      window.dispatchEvent(new CustomEvent('compareCountUpdate', { 
        detail: { count: products.length } 
      }));
    }

    // Event delegation for compare buttons
    document.addEventListener('click', function(e) {
      const compareBtn = e.target.closest('.compare-btn');
      if (compareBtn) {
        e.preventDefault();
        e.stopPropagation();
        
        // Validate product data before adding
        const productData = {
          handle: compareBtn.dataset.productHandle || '',
          title: compareBtn.dataset.productTitle || 'Product',
          price: compareBtn.dataset.productPrice || '$0.00',
          image: compareBtn.dataset.productImage || '',
          url: compareBtn.dataset.productUrl || '#'
        };
        
        // Only add if we have at least a handle and title
        if (productData.handle && productData.title !== 'Product') {
          window.addToCompare(productData);
        }
      }
    });

    // Initialize on page load
    updatePanelDisplay();
  })();
  } catch(e) { console.error(e); }
})();

})();
